import { render, staticRenderFns } from "./AppendCandidate.vue?vue&type=template&id=782eb4bf&scoped=true&lang=pug"
import script from "./AppendCandidate.vue?vue&type=script&lang=ts"
export * from "./AppendCandidate.vue?vue&type=script&lang=ts"
import style0 from "./AppendCandidate.vue?vue&type=style&index=0&id=782eb4bf&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782eb4bf",
  null
  
)

/* custom blocks */
import block0 from "./Candidates.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FCompliance%2FCandidates%2FAppendCandidate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports